export default {
  "t-physical-examination": "Физическое обследование",
  "t-physical-examination-logs": "Отчет проверка оборудования",
  "t-terminal-data-upload-configuration": "Конфигурация загрузки данных терминала",
  "t-terminal-strategy-parameters": "Параметры стратегии терминала",
  "t-strategy-execution-report": "Отчет о выполнении стратегии",
  "t-terminal-data-analysis": "Анализ данных терминала",
  "t-configuration-parameters": "Параметры конфигурации",
  "t-data-alert-config": "Конфигурация данных и оповещений",
  "t-data-upload-alert-event-config": "Конфигурация загрузки данных и событий оповещения",
  "t-history": "История",
  "t-health-check-date": "Дата проверки здоровья",
  "t-health-score": "Оценка здоровья",
  "t-check-items": "Пункты проверки",
  "t-detection-status": "Состояние проверки оборудования",
  "t-device-basic-info": "Основная информация об устройстве",
  "t-healthy": "Здоровый",
  "t-optimal": "Нормальный",
  "t-unhealthy": "Нездоровый",
  "t-skip": "Пропустить",
  "t-printer": "Принтер",
  "t-voltage": "Напряжение",
  "t-temperature": "Температура",
  "t-charging-status": "Состояние зарядки",
  "t-print-distance": "Расстояние печати",
  "t-print-head-size": "Размер печатной головки",
  "t-bootloader-version": "Версия загрузчика",
  "t-internal-software-version": "Версия внутреннего ПО",
  "t-uptime": "Время работы",
  "t-detection-content": "Всего протестировано {total} элементов, из них {pass} пройдено, {skip} пропущено",
  "t-not-charging": "Не заряжается",
  "t-charging": "Заряжается",
  "t-closed": "Закрыто",
  "t-opened": "Открыто",
  "t-mobile-data": "Мобильные данные",
  "t-wifi": "WIFI",
  "t-unknown": "Неизвестно",
  "t-medical-inspection": "Медицинский осмотр",
  "t-health-status": "Состояние здоровья",
  "t-manual": "Ручной",
  "t-automatic": "Автоматический",
  "t-manual-physical-examination-type": "Ручной",
  "t-automatic-physical-examination-type": "Автоматический",
  "t-device-data-acquisition": "Сбор данных устройства",
  "t-device-data-stop-collection": "Остановить сбор данных устройства",
  "t-device-health-check": "Проверка здоровья устройства",
  "t-auto-health-check": "Автоматическая проверка здоровья",
  "t-tha-logs": "Журналы проверки здоровья THA",
  "t-battery-brand": "Бренд",
  "t-charging-duration": "Продолжительность зарядки",
  "t-charging-current": "Ток зарядки",
  "t-charge-cycles": "Циклы зарядки",
  "t-charge-cycle-count": "Количество циклов зарядки",
  "t-low-temperature-warning-count": "Количество предупреждений о низкой температуре",
  "t-high-temperature-warning-count": "Количество предупреждений о высокой температуре",
  "t-data-upload": "Список загрузки данных",
  "t-alert-event": "Событие оповещения",
  "t-device-config": "Конфигурация устройства THA",
  "t-config-sync-log": "Журнал синхронизации конфигурации",
  "t-event-trigger-time": "Время срабатывания события",
  "t-event-upload-time": "Время загрузки события",
  "t-battery-overheating": "Предупреждение о высокой температуре батареи",
  "t-battery-undervoltage": "Предупреждение о низкой температуре батареи",
  "t-cpu-overheating": "Отключение из-за высокой температуры батареи",
  "t-event-battery-high-temperature": "Предупреждение о высокой температуре батареи",
  "t-event-battery-low-temperature": "Предупреждение о низкой температуре батареи",
  "t-event-cpu-high-temperature": "Высокая температура процессора",
  "t-event-battery-high-temperature-shutdown": "Отключение из-за высокой температуры батареи",
  "t-event-battery-low-temperature-shutdown": "Отключение из-за низкой температуры батареи",
  "t-event-type": "Тип события",
  "t-total-records": "Всего записей",
  "t-peripheral": "Периферийное устройство",
  "t-module": "Модуль",
  "t-sampling-period": "Период выборки",
  "t-sampling-period-1-minute": "1 минута",
  "t-sampling-period-3-minutes": "3 минуты",
  "t-sampling-period-5-minutes": "5 минут",
  "t-sampling-period-10-minutes": "10 минут",
  "t-sampling-period-30-minutes": "30 минут",
  "t-sampling-period-60-minutes": "60 минут",
  "t-upload-interval": "Интервал загрузки",
  "t-upload-interval-less-than-sampling-period": "Интервал загрузки не может быть меньше периода выборки",
  "t-sample-count": "Количество выборок",
  "t-valid-sample-count": "Количество валидных выборок",
  "t-upload-timestamp": "Временная метка загрузки",
  "t-sample-timestamp": "Временная метка выборки",
  "t-config-sync-logs": "Журналы синхронизации конфигурации",
  "t-data-point": "Точка данных",
  "t-policy-updated": "Политика была обновлена",
  "t-policy-consistent": "Политика согласована",

// 应用信息
  "t-app-name": "Название приложения",
  "t-package-name": "Имя пакета",
  "t-is-system": "Системное приложение?",
  "t-app-version": "Версия приложения",
  "t-authorisations": "Разрешения",
  "t-installed-at": "Установлено",
  "t-app-size": "Размер",
// 网络流量统计
  "t-uplink-traffic": "Трафик восходящей линии",
  "t-downlink-traffic": "Трафик нисходящей линии",
  "t-traffic-total": "Общий трафик",
  "t-monitor-more": "еще",
// 网络连接状态
  "t-router-name": "Имя маршрутизатора",
// 外设使用统计
  "t-swipe-card-count": "Количество проведенных карт",
  "t-insert-card-count": "Количество вставленных карт",
  "t-tap-card-count": "Количество приложенных карт",
  "t-card-fail-count": "Количество сбоев карты",
  "t-print-mileage": "Расстояние печати",
  "t-print-speed": "Скорость печати",
  "t-print-grayscale": "Оттенки серого печати",

  "t-open-tha-model-waiting": "Запрос THA был инициирован, пожалуйста, подождите ..",
  "t-manually-initiated-health-check-failed": "Не удалось вручную инициировать проверку состояния",
  "t-health-check-initialization-failed": "Не удалось инициализировать проверку состояния",
  "t-manually-initiated-health-check-success": "Проверка состояния успешно запущена, см. отчет о проверке состояния устройства",
  "t-monitor-abnormal": "Abnormal",
  "t-monitor-start-date": "Start Date",
  "t-monitor-end-date": "End Date",
  "t-monitor-battery-status": "Battery Status",
  "t-monitor-current-capacity": "Уровень заряда батареи",
  "t-monitor-key-focus": "Key Focus",
  "t-monitor-battery-trend": "Battery Trend",
  "t-monitor-temperature-battery-threshold": "Temperature Threshold / Battery Threshold",
  "t-monitor-system-resource-trend": "System Resource Trend",
  "t-monitor-storage-high": "High Storage Usage",
  "t-monitor-network-traffic-trend": "Network & Traffic Trend",
  "t-monitor-link-stable": "Stable Link",
  "t-monitor-data-summary": "Data Summary",
  "t-monitor-metric": "Metric",
  "t-monitor-current-value": "Current",
  "t-monitor-minimum-value": "Minimum",
  "t-monitor-maximum-value": "Maximum",
  "t-monitor-average-value": "Average",
  "t-threshold": "Threshold",
  "t-monitor-unit-times": "times",
  "t-monitor-unit-meter": "m",
  "t-monitor-no-sampling-time": "No sampling time",
  "t-monitor-device-info": "Device Info",
  "t-monitor-software-version": "Software Version",
  "t-monitor-sma-version": "SMA Version",
  "t-monitor-pos-service": "POS Service",
  "t-monitor-network-connection": "Network Connection",
  "t-monitor-ip-address": "IP Address",
  "t-monitor-mac-address": "MAC Address",
  "t-monitor-battery-info": "Battery Info",
  "t-monitor-battery-brand": "Battery Brand",
  "t-monitor-collection-summary": "Collection Summary",
  "t-monitor-valid-rate": "Valid Rate",
  "t-monitor-battery-level": "Battery",
  "t-monitor-current": "Current",
  "t-monitor-over-threshold": "Over Threshold",
  "t-monitor-below-threshold": "Below Threshold",
  "t-monitor-idle": "Idle",
  "t-monitor-charge-cycle-stats": "Charge Cycle Statistics",
  "t-monitor-high": "High",
  "t-monitor-charge-count": "Charge Count",
  "t-monitor-cumulative": "Cumulative",
  "t-monitor-current-cycle": "Current Cycle",
  "t-monitor-high-temperature-warning": "High Temp Warning",
  "t-monitor-severe": "Severe",
  "t-monitor-controllable": "Controllable",
  "t-monitor-low-temperature-warning": "Low Temp Warning",
  "t-monitor-system-resource": "System Resource",
  "t-monitor-network-signal": "Network Signal",
  "t-monitor-weak": "Weak",
  "t-monitor-good": "Good",
  "t-monitor-stable": "Stable",
  "t-monitor-application-traffic": "Application Traffic",
  "t-monitor-current-sample": "Current Sample",
  "t-monitor-peripheral-stats": "Peripheral Stats",
  "t-monitor-need-attention": "Needs Attention",
  "t-monitor-usage": "Usage",
  "t-monitor-ethernet": "Ethernet",
  "t-monitor-link-normal": "Link Normal",
  "t-monitor-fetch-failed": "Failed to fetch monitor data",
  "t-version-change-timeline": "Хронология изменений версии ПО",
  "t-version-change-count": "{count} изменений версии",
  "t-version-timeline-empty": "Нет записей об изменении версии",
  "t-version-timeline-multiple-events": "Несколько событий",
  "t-version-timeline-event": "Событие",
  "t-version-timeline-init": "Инициализация",
  "t-version-timeline-update": "Обновление версии",
  "t-version-timeline-upgrade": "Обновление",
  "t-version-timeline-rollback": "Откат",
  "t-version-timeline-exception": "Исключение",
  "t-version-timeline-current": "Текущая",
  "t-data-upload-data": "Обзор данных THA",
  "t-tha-data-overview": "Обзор данных THA",
  "t-manual-physical-examination-and-automatic-physical-examination": "При ручном физическом тестировании устройство должно установить POS Manager, данное приложение используется для проверки дисплея, сенсорного экрана, камеры, динамика, клавиш, сканирования отпечатков пальцев, микрофона, модуля считывания магнитных полос, считывателя карт с чипом, считывателя карт без касания, принтера, индикатора состояния, буаззера и модуля безопасного хранения платежей. Также включает элементы автоматического физического тестирования: серийный номер устройства, время тестирования, состояние Bluetooth, текущее использование процессора, текущее использование оперативной памяти, текущее использование памяти хранения, время включения, геолокация, состояние зарядки, температура батареи, напряжение батареи, уровень заряда батареи, тип связи, тип сигнала, адрес роутера, скорость передачи, адрес MAC WiFi, уровень сигнала, переключатель сети и расстояние печати",
  "t-manual-physical-examination-and-automatic-physical-examination-auto": "При автоматическом физическом тестировании устройство не требует установки POS Manager, это приложение используется для проверки серийного номера устройства, времени тестирования, состояния Bluetooth, текущего использования процессора, текущего использования оперативной памяти, текущего использования памяти хранения, времени включения, геолокации, состояния зарядки, температуры батареи, напряжения батареи, уровня заряда батареи, типа связи, типа сигнала, адреса роутера, скорости передачи, адреса MAC WiFi, уровня сигнала, переключателя сети и расстояния печати",
  "t-power-level": "Уровень питания",
}
